import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../services/supabase'

/**
 * Hook para verificar se o usuário tem assinatura
 * Se não tiver, redireciona para /assinar
 */
export const useCheckSubscription = () => {
    const { user, loading } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        const checkSubscription = async () => {
            // Aguardar o carregamento do usuário
            if (loading) return

            // Se não está logado, não faz nada
            if (!user) return

            try {
                // Verificar se o usuário tem alguma assinatura
                const { data: assinaturas, error } = await supabase
                    .from('assinaturas')
                    .select('id')
                    .eq('user_id', user.id)
                    .limit(1)

                if (error) {
                    console.error('Erro ao verificar assinatura:', error)
                    return
                }

                // Se não tem nenhuma assinatura, redireciona para /assinar
                if (!assinaturas || assinaturas.length === 0) {
                    console.log('Usuário sem assinatura, redirecionando para /assinar')
                    navigate('/assinar', { replace: true })
                }
            } catch (error) {
                console.error('Erro ao verificar assinatura:', error)
            }
        }

        checkSubscription()
    }, [user, loading, navigate])
}
